<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas35bg.svg" />

    <p class="textBase hover-animation-c appearAnimationA" id="tag01">
      LOS CASTILLOS SOLÍAN TENER
    </p>
    <p class="textBase appearAnimationB" id="text01">UN PATIO INTERNO</p>

    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >CASI TODOS LOS CASTILLOS TENÍAN UN PATIO INTERNO.
      <input
        type="radio"
        name="castillos"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >TODOS LOS CASTILLOS TENÍAN UN PATIO INTERNO.
      <input
        type="radio"
        name="castillos"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 65px;
  top: 426px;
}
#tag01 {
  position: absolute;
  width: 430px;
  height: 50px;
  left: 70px;
  top: 123px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
}
#text01 {
  position: absolute;
  width: 730px;
  left: 520px;
  top: 127px;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #000000;
}
#text02 {
  position: absolute;
  left: 69px;
  top: 192px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 65px;
  top: 272px;
}
#toggle02 {
  position: absolute;
  left: 65px;
  top: 349px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 134.mp4", "cas/Video 135-136-137.mp4", "cas/Video 139.mp4"],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>